<!--
    校区管理-上课统计-详情
    功能：展示每条上课数据中的上课情况、上课明细
-->
<template>
  <div class="statistical_class">
    <div class="top">
      <p>课题：{{ info.name }}</p>
      <p>授课老师：{{ info.teacher.name }}</p>
      <p>上课时间：{{ info.time }}</p>
      <p>上课时长：{{ info.sec }}</p>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="上课情况"
        name="first">
        <AppList
          v-if="activeName === 'first'"
          ref="list"
          :list.sync="list_first"
          :api="`${apiUrl}/api/liveroom/teacher/action/${id}`"
          title="">
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columns_first"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <!--<el-table-column
                label="操作"
                width="160px"
                class="orgin-btn"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="StatisticalClass(scope.row.id)"
                  >异常日志下载</el-button>
                </template>
              </el-table-column>-->
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane
        label="视频录制统计"
        name="record">
        <AppList
          v-if="activeName === 'record'"
          ref="list"
          :list.sync="list_record"
          :api-type="`${apiUrl}/api/record?equal[liveroom_id]=${id}`"
          title=""
          api="/api/record">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrRecord"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columns_record"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="学生端回放"
              >
                <template slot-scope="scope">
                  <el-switch
                    :value="scope.row.use_status == '1'"
                    active-color="#13ce66"
                    inactive-color="#e3e3e3"
                    @change="switchStatus(scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="160px"
                class="orgin-btn"
              >
                <template slot-scope="scope">
                  <el-link
                    v-if="$store.state.from === 'schoolCenter'"
                    @click="editName(scope.row)"
                  >编辑</el-link>
                  <el-button
                    v-else
                    size="small"
                    @click="editName(scope.row)"
                  >编辑</el-button>
                  <!--                  <el-button-->
                  <!--                    size="small"-->
                  <!--                    @click="StatisticalClass(scope.row)"-->
                  <!--                  >播放</el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane
        label="视频回放统计"
        name="replay">
        <div class="replay">
          <el-date-picker
            v-model="dateValue"
            :picker-options="expireTimeOption"
            :clearable="false"
            class="month_picker"
            type="month"
            size="mini"
            value-format="yyyy-MM"
            placeholder="选择月份"
            @change="changeDate"/>
          <div class="count">
            <div class="box">
              <p>{{ count.month_numbers }}</p>
              <p>月回放次数</p>
            </div>
            <div class="box">
              <p>{{ count.total }}</p>
              <p>总回放次数</p>
            </div>
          </div>
        </div>
        <AppList
          v-if="activeName === 'replay'"
          ref="list"
          :list.sync="list_replay"
          :api-type="`${apiUrl}/api/replay?equal[liveroom_id]=${id}&order[start_time]=desc`"
          title=""
          api="/api/replay">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrReplay"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columns_replay"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane
        label="上课学生明细"
        name="four">
        <AppList
          v-if="activeName === 'four'"
          ref="list"
          :list.sync="list_four"
          :api="`/api/liveroom/${id}/student`"
          :api-type="`${apiUrl}/api/liveroom/${id}/student?is_show_classes=1`"
          title="">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrFour"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columns_four"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="进出直播间情况"
                width="160px"
                class="orgin-btn">
                <template slot-scope="scope">
                  <el-link
                    v-if="$store.state.from === 'schoolCenter'"
                    @click="Detail(scope.row)"
                  >明细</el-link>
                  <el-button
                    v-else
                    size="small"
                    @click="Detail(scope.row)"
                  >明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      class="dialog"
      title="明细"
      width="600px">
      <el-table
        ref="table"
        :data="formData"
        :border="true">
        <el-table-column
          :formatter="(row) => {
            const action = {
              1: '进入直播间',
              2: '退出直播间',
              3: '老师结束直播'
            }
            return row.action ? action[row.action] : '签到成功'
          }"
          prop="name"
          label="操作动作"
        />
        <el-table-column
          prop="created_at"
          label="时间"
        />
        <!--        <el-table-column-->
        <!--          prop="amount"-->
        <!--          label="进入时设备情况"-->
        <!--        />-->
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import baseUrl from '../../utils/api';
import merge from 'webpack-merge';

export default {
  name: 'StatisticalClass',
  inject: ['reload'],
  data() {
    return {
      id: this.$route.params.id,
      typeId: this.$route.query.id,
      activeName: 'first',
      info: {
        name: '',
        teacher: {
          name: '',
        },
        time: '',
        sec: '',
      },
      columns_first: [],
      columns_record: [],
      columns_replay: [],
      columns_four: [],
      list_first: {},
      list_record: {},
      list_replay: {},
      list_four: {},
      dialogVisible: false,
      formData: [],
      apiUrl: '',
      dateValue: '',
      expireTimeOption: {
        disabledDate(time) {
          return time.getTime() < 1585670400000; // 禁用2020-04以前的日期
        },
      },
      count: {
        month_numbers: 0,
        total: 0,
      },
    };
  },
  computed: {
    searchArrRecord() {
      const column = [
        { prop: 'id', label: '视频号' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    searchArrReplay() {
      const column = [
        { prop: 'student_name', label: '学生名字' },
        { prop: 'student_mobile', label: '手机号' },
        { prop: 'record_id', label: '视频号' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    searchArrFour() {
      return [
        {
          componentType: 'AppSearchColumn',
          searchType: [
            { prop: 'name', label: '学生姓名' },
            { prop: 'mobile', label: '手机号' },
          ],
        },
      ];
    },
    school() {
      return this.$store.state.school;
    },
  },
  created() {
    const active = this.$route.query.activeName;
    this.activeName = active && active != 'undefined' ? active : 'first';
    // 上课情况
    this.columns_first = [
      {
        prop: 'action',
        label: '操作动作',
        formatter: (row) => {
          const action = {
            1: '进入直播间',
            2: '退出直播间',
            3: '开始上课',
            4: '结束上课',
            5: '取消上课',
          };
          return action[row.action];
        },
      },
      { prop: 'created_at', label: '时间点' },
      {
        label: '上课时长（时分秒）',
        formatter: (row) => {
          const time = this.$setting.setTime(row.liveroom_second);
          return row.action === 4 ? `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}` : '00:00:00';
        },
      },
      { prop: 'student_count', label: '上课总人次' },
    ];
    // 录制统计
    this.columns_record = [
      { prop: 'name', label: '视频名称' },
      { prop: 'id', label: '视频号' },
      {
        label: '录制时间',
        width: '170px',
        formatter: row => `${row.start_time} - ${row.end_time}` },
      {
        label: '录制时长',
        formatter: (row) => {
          const time = this.$setting.setTime(row.video_seconds);
          return `${time.hourTime}:${time.min}:${time.sec}`;
        },
      },
      {
        label: '文件大小',
        formatter: row => this.$setting.getFileSize(row.resource_size),
      },
    ];
    // 回放统计
    this.columns_replay = [
      {
        label: '学生或老师名字',
        formatter: row => row.student_name || row.staff_name,
      },
      {
        label: '手机号',
        formatter: row => row.student_mobile || row.staff_mobile,
      },
      {
        label: '观看时间',
        width: '170px',
        formatter: row => `${row.start_time} - ${row.end_time}`,
      },
      { prop: 'record_id', label: '视频号' },
      {
        label: '观看时长',
        formatter: (row) => {
          const time = this.$setting.setTime(row.watch_seconds);
          return `${time.hourTime}:${time.min}:${time.sec}`;
        },
      },
    ];
    // 学生明细
    this.columns_four = [
      { prop: 'student.name', label: '学生姓名' },
      { prop: 'student.mobile', label: '学生手机号' },
      { prop: 'classes.name', label: '所属班级' },
      {
        label: '观看上课时长',
        formatter: (row) => {
          const sec = this.$setting.setTime(row.act_watch_second);
          return `${sec.hour}:${sec.min}:${sec.sec}`;
        },
      },
      {
        label: '是否出勤',
        formatter: (row) => {
          const sec = row.be_present === 1 ? '是' : '否';
          return sec;
        },
      },
      // { prop: 'name', label: '上课答题次数' },
      // { prop: 'name', label: '课中分数' },
    ];
    if (this.typeId) {
      this.school.forEach((item) => {
        if (item.id === Number(this.id)) {
          this.apiUrl = `${this.$checkHttp()}${item.domain}`;
        }
      });
    } else {
      this.apiUrl = `${this.$checkHttp()}${this.$store.state.choicesSchool.domain}`;
    }
    this.$http.get(`${this.apiUrl}/api/liveroom?is_show_teacher=1&equal[id]=${this.id}`)
      .then((res) => {
        this.info = res.items[0];
        let time = '';
        switch (this.info.status) {
          case 1: // 未开始 展示预设直播开始时间~--
            time = `${this.info.start_time} ~ --`;
            break;
          case 2: // 直播中 展示实际直播开始时间~--
            time = `${this.info.begin_time} ~ --`;
            break;
          case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
            time = `${this.info.begin_time} ~ ${this.info.close_time}`;
            break;
          case 4: // 缺课 预设时间~--
            time = `${this.info.start_time} ~ --`;
            break;
          case 5: // 已取消 预设时间~--
            time = `${this.info.start_time} ~ --`;
            break;
          default:
            break;
        }
        const sec = this.$setting.setTime(this.info.act_liveroom_second);
        this.info.time = time;
        this.info.sec = `${this.timeFamate(Number(sec.day || 0) * 24 + Number(sec.hour))}:${sec.min}:${sec.sec}`;
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    const time = this.$moment(new Date()).format('YYYY-MM');
    this.load(time);
  },
  methods: {
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    handleClick() {
      this.$router.replace({
        query: merge({ page: 1, per_page: 10, 'order[id]': 'desc' }),
      });
    },
    editName(row) {
      this.$prompt('请输入视频名称', '修改视频名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: val => !!val,
        inputErrorMessage: '请输入视频名称',
      }).then(({ value }) => {
        const data = {
          name: value,
        };
        this.$http
          .put(`${this.apiUrl}/api/record/${row.id}`, data)
          .then((res) => {
            this.$message.success('状态视频名称成功');
            this.reload();
          });
      });
    },
    // 修改状态
    switchStatus(row) {
      const use_status = {
        use_status: row.use_status === 1 ? 0 : 1,
      };
      this.$confirm('确定修改状态吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .put(`${this.apiUrl}/api/record/${row.id}`, use_status)
            .then((res) => {
              this.$message.success('状态修改成功');
              this.reload();
            });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    Detail(row) {
      this.$http.get(`/api/liveroom/watch/${this.id}/${row.student_id}`)
        .then((res) => {
          this.formData = [];
          this.dialogVisible = true;
          this.formData.push(...res.sign);
          this.formData.push(...res.watch);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    load(time) {
      const date = time.split('-');
      this.$http.get(`${this.apiUrl}/api/replay/${this.id}/${date[0]}/${date[1]}`)
        .then((res) => {
          this.count = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
      console.log(date);
    },
    changeDate(val) {
      this.load(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.statistical_class {
  .top {
    font-size: 16px;
    color: #606266;
    p {
      display: inline-block;
      margin-right: 40px;
    }
  }
  .el-tab-pane {
    position: relative;
  }
  .total_span {
    font-size: 16px;
    color: var(--color-primary);
    position: absolute;
    left: 10px;
    top: 20px;
  }
  .replay {
    position: relative;
    .count {
      display: flex;
      div.box {
        flex: 1;
        margin-right: 20px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        padding: 40px 20px;
        text-align: center;
        &:last-child {
          margin: 0;
        }
        p {
          color: #909399;
          &:first-child {
            color: #333;
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
    }
    .month_picker {
      width: 120px;
      margin-top: 7px;
      margin-left: 15px;
      position: absolute;
      left: 10px;
      top: 10px;
    }
  }
}
</style>
<style lang="scss">
  .statistical_class {
    #pane-first {
      .list-header {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Statistical/StatisticalClass.vue